import React from 'react';
import styles from './formsBrowser.module.scss';
import { getFavoritedForms } from './services/formsBrowserService';
import { Form } from './Form';
import { useTranslation } from 'react-i18next';
import {
    FormProps,
    LocalStorageProps,
    SelectionProps,
} from './types/FormTypes';

export const FavoritedForms = React.memo(
    (props: {
        selectionProps: SelectionProps;
        localStorageProps: LocalStorageProps;
    }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                selectionProps: { allForms },
                localStorageProps: { favoritedFormIds, removeFavoritedFormId },
            } = props;

            if (favoritedFormIds?.length) {
                return (
                    <>
                        <div className={styles.formsGalleryViewContainer}>
                            <div
                                className={styles.formsGalleryViewSubContainer}
                            >
                                {getFavoritedForms(
                                    favoritedFormIds,
                                    allForms,
                                    removeFavoritedFormId,
                                )?.map((form: FormProps, index) => (
                                    <div key={index}>
                                        <Form
                                            form={form}
                                            selectionProps={selectionProps}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                );
            } else {
                return <div>{t('FormsBrowser.FavoritedDescription')}</div>;
            }
        } catch {
            return null;
        }
    },
);
